<template>

</template>

<script>
import alert from '@/accessibility/Alert'
import spinner from '@/accessibility/Spinner'
import input from '@/accessibility/Input'
import { mapGetters } from 'vuex'
export default {
    components: {
        'bs-input': input,
        alert,
        spinner
    },
    name: 'validate',
    metaInfo () {
        return {
            title: 'TONE | Redeem Your Gift',
            meta: [
                {property: 'og:image', content: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/slide-1.jpg'},
                {property: 'og:title', content: 'TONE | Redeem Your Gift'},
                {property: 'og:site_name', content: 'TONE Networks | Expert Advice on Demand'},
                {
                    property: 'og:description',
                    content: 'TONE Networks is a highly personalized, online learning and coaching platform designed to develop early to mid-career professionals thrive in an increasingly competitive workplace.'
                },
                {property: 'twitter:title', content: 'TONE | Redeem Your Gift'},
                {property: 'twitter:card', content: 'summary'},
                {property: 'twitter:image', content: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/slide-1.jpg'},
                {
                    property: 'twitter:description',
                    content: 'TONE Networks provides women with resources and support to help them flourish in every aspect of their lives.'
                },
                {property: 'og:image:width', content: '300'},
                {property: 'og:image:height', content: '300'}
            ]
        }
    },
    data: function () {
        return {
            userObj: {
                email: '',
                code: '',
                validationCode: ''
            },
            spinner: false,
            paramEmail: '',
            paramValidationCode: '',
            validationSuccess: false
        }
    },
    computed: {
        ...mapGetters([
            'error', 'user', 'getValidationStatusError', 'getCorpReference'
        ])
    },
    methods: {},
    mounted: function () {
        let self = this
        self.$store.dispatch('CACHEPAGE', window.location.href)
        if (self.user) {
            self.$router.push('/mytone')
        } else {
            self.$store.dispatch('GET_CORP_BY_GIFTCODE', self.$route.params.giftCode).then(() => {
                if (self.getCorpReference) {
                    let giftingUrl = ''
                    if (self.getCorpReference.invitationCode === '1') {
                        giftingUrl = `/corporationgifting/${self.getCorpReference.corporationId}/${self.getCorpReference.userComments}`
                    } else {
                        giftingUrl = `/corporation/referral/buy/${self.getCorpReference.corporationId}/${self.getCorpReference.userComments}`
                    }
                    console.log('gift found url: ', giftingUrl)
                    self.$router.push(`${giftingUrl}`)
                } else {
                    console.log('gift not found')
                    self.$router.push('/')
                    self.$swal({
                        title: 'Invalid Gift Code',
                        text: '',
                        type: 'error',
                        timer: 3000,
                        showCancelButton: false,
                        showConfirmButton: false
                    }).then(
                        function () {
                        },
                        // handling the promise rejection
                        function (dismiss) {
                            if (dismiss === 'timer') {
                            }
                        }
                    )
                }
            })
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .validate .form{
        text-align: left;
        width: 40%;
        margin: 50px auto;
    }
    h2.heading {
        color: #f0617d;
        text-transform: capitalize;
        margin: 47px 0 35px 0;
        letter-spacing: 0.5px;
        font-family: sans-serif;
        font-size: 30px;
    }
    .validate h1{
        font-size: 32px;
        color: #009cf6;
        font-weight: lighter;
        margin: 0 0 25px 0;
    }
    .validate p{
        font-size: 14px;
        color: #979797;
        margin: 0;
    }
    .padding-minus{
        padding:0;
    }
    .validate .form .form-input{
        margin-bottom: 25px ;
    }
    .validate .form .forgotPassword{
        float: right;
        color: black
    }
    .validate .form .forgotPassword:hover{
        float: right;
        color: #337ab7;
    }
    .formButton{
        margin: 25px 0 50px;
        width: 130px;
        height: 47px;
        color: #91ab45;
        border-color: #91ab45;
        background-color: transparent;
        transition: 0.5s;
        padding:0;
    }
    .formButton a{
        display: block;
        padding: 13px 12px;
        color: #91ab45;
        text-decoration: none;
        transition: 0.5s;
    }
    .formButton:hover{
        border-color: #91ab45;
        background-color: #91ab45;
        transition: 0.5s;
        color: #ffffff;
    }
    .btn-spinner{
        bottom:15px
    }
</style>



// WEBPACK FOOTER //
// GiftRedirect.vue?6f19e458